"use client";

import clsx from "clsx";

type ItemToggleButtonProps = {
  label: string;
  active?: boolean;
  onClick?: () => void;
  className?: string;
};

export default function ItemToggleButton({
  label,
  active = false,
  onClick,
  className,
}: ItemToggleButtonProps) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        `
        px-5 py-2
        text-sm uppercase tracking-wide
        border
        transition-all duration-200 ease-out
        `,
        active
          ? "bg-primary text-white border-primary shadow-md"
          : "border-primary/30 text-primary/70 hover:border-primary hover:text-primary",
        className
      )}
    >
      {label}
    </button>
  );
}
